import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/apiUrlHelper';
import { Subscription, interval } from 'rxjs';
import { VerificationOTP } from '../../constants/message-constant';
import { VerificationPageLabel } from 'src/app/constants/label-constants';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss']
})
export class VerificationCodeComponent implements OnInit {
  verificationCodeForm: FormGroup = this.formBuilder.group({});;
  queryString = Object();
  emailAddress: any;
  otp: string = '';
  verificationPageLabel:any=[];
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  countDown!: Subscription;
  counter = 121;
  tick = 1000;
  isDisabled: boolean = true;
  submitted = false;
  isCounterShow: boolean = true;
  interval: any;
  minutes: any = 2;
  seconds: any = 0;
  isTimerRunning: boolean = false;
  isResendDisabled = false;
  private subscription: Subscription = new Subscription;
  constructor(
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toster: ToastrService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.onLoad();
    this.initVerificationCodeForm();
    this.verificationPageLabel=VerificationPageLabel;
    // Set the initial time values
    this.minutes = 2;
    this.seconds = 0;
    // Start the timer immediately
    setTimeout(() => {
      this.startTimer();
    }, 0);
  }

  goLogin(){
    this.router.navigate(['/login'])
  }

  timeCalculate() {
    if (this.isTimerRunning) {
      return; // Exit if the timer is already running
    }
    this.isTimerRunning = true;
    this.subscription = interval(1000).subscribe(() => {
      if (this.counter > 0) {
        --this.counter;
      } else {
        this.isDisabled = false;
        this.isCounterShow = false;
        this.subscription?.unsubscribe(); // Unsubscribe from the interval
        this.ngOtpInput.otpForm.disable();
        this.isTimerRunning = false; // Reset the timer status
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe(); // Unsubscribe from the interval if the component is destroyed
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

  onLoad() {
    this.activatedRoute.params.subscribe(parms => {
      this.queryString = parms[''];
      let emailadd = parms[''];
      this.emailAddress = atob(emailadd);
    });
  }

  initVerificationCodeForm() {
    this.verificationCodeForm = this.formBuilder.group({
      code: ['']
    });
  }
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '1',

  };

  verificationCode() {
    // this.ngOtpInput.otpForm;
    if (!this.otp) {
      this.toster.error(VerificationOTP.NO_OTP)
      return false;
    }
    else if (this.otp.length != 6) {
      this.toster.error(VerificationOTP.INVALID_OTP);
      return false;
    }
    this.submitted = true;
    this.spinner.show();
    const objData = {
      EmailId: this.emailAddress,
      OTP: this.otp
    }
    const apiUrl = this.apiUrl.apiUrl.verificationOTP.verificationOTP;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (data) => {
        if (data.success) {
          this.toster.success(data.message);
          this.spinner.hide();
          this.router.navigate(['/recover-password' + '/' + btoa(this.emailAddress)]);
        }
        else {
          this.spinner.hide();
          this.toster.error(data.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.commonService.checkAuthorize(error);
      }
    });
    return true;
  }

  onOtpChange(event: any) {
    this.otp = event;
  }

  ResendOTP() {
    this.spinner.show();
    this.ngOtpInput.setValue('');
    this.ngOtpInput.otpForm.enable();
    this.counter = 121;
    this.isDisabled = true;
    this.isCounterShow = true;
    const objData = {
      EmailId: this.emailAddress
    }
    const apiUrl = this.apiUrl.apiUrl.forgotPassword.ForgetPassword;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (data) => {
        if (data.success) {
          this.spinner.hide();
          this.toster.success(data.message);
          this.startTimer(); // Start the timer after resetting
        } else {
          this.spinner.hide();
          this.toster.error(data.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.commonService.checkAuthorize(error);
      }
    });
  }

  startTimer() {
    this.subscription?.unsubscribe(); // Unsubscribe from the previous subscription if exists
    this.subscription = interval(1000).subscribe(() => {
      if (this.counter === 0) {
        this.handleTimerEnd();
        this.subscription?.unsubscribe();
      } else {
        this.counter--;
        this.minutes = Math.floor(this.counter / 60);
        this.seconds = this.counter % 60;
        this.minutes = this.minutes.toString().padStart(2, '0');
        this.seconds = this.seconds.toString().padStart(2, '0');
        this.isResendDisabled = true;
      }
    });
  }

  handleTimerEnd() {
    this.subscription.unsubscribe();
    this.verificationCodeForm.disable();
    this.isResendDisabled = false;
  }
}
